export default "__VITE_ASSET__TpadG6Iy__"